import styled from 'styled-components';
import { SaveYourProjectAndContinueStyled } from '../SaveYourProjectAndContinueStyled';
export const SaveYourProjectAndContinueStyledDS = styled(SaveYourProjectAndContinueStyled)`
    .button > button {
        height: 100%;
    }
`;
